import React from "react";
import { Input } from "@heroui/react";
import { Icon } from "@iconify/react";

const NumberInput = ({
    label,
    value,
    onChange,
    isReadOnly = false,
    className = "",
    icon = "lucide:hash",
    min = 0,
    max = 9999,
    ...props
}) => {
    // Permitir solo números enteros positivos
    const handleChange = (e) => {
        const val = e.target.value;
        // Permitir campo vacío
        if (val === "") {
            onChange("");
            return;
        }
        // Permitir solo números
        if (/^\d+$/.test(val)) {
            // Validar rango
            const num = parseInt(val, 10);
            if (num >= min && num <= max) {
                onChange(val);
            }
        }
    };

    return (
        <Input
            label={label}
            value={value || ""}
            onChange={handleChange}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            startContent={
                <Icon
                    icon={icon}
                    className="text-default-400 pointer-events-none flex-shrink-0"
                />
            }
            classNames={{
                label: "text-sm font-medium",
                input: "text-sm",
            }}
            isReadOnly={isReadOnly}
            className={className}
            {...props}
        />
    );
};

export default NumberInput; 